import React, { useState } from 'react';
import { ref, push } from 'firebase/database';
import { db } from './firebase-config';
import './Home.css';

function HomeApplyForm() {
  const [applicationType, setApplicationType] = useState('artist');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [link, setLink] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState('');

  const handleTypeChange = (type) => {
    setApplicationType(type);
    setLink(''); // Reset link when changing type
  };

  const validateForm = () => {
    if (!name.trim()) {
      setError('Please enter your name');
      return false;
    }
    
    if (!email.trim() || !email.includes('@') || !email.includes('.')) {
      setError('Please enter a valid email address');
      return false;
    }
    
    if (!link.trim()) {
      const linkType = applicationType === 'artist' ? 'Spotify link' : 'website link';
      setError(`Please enter your ${linkType}`);
      return false;
    }
    
    if (!acceptTerms) {
      setError('Please accept the terms of use');
      return false;
    }
    
    setError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    
    try {
      const applicationData = {
        type: applicationType,
        name,
        email,
        link,
        message,
        createdAt: new Date().toISOString()
      };
      
      // Speichern in Firebase
      await push(ref(db, 'applications'), applicationData);
      
      // Formular zurücksetzen und Erfolg anzeigen
      setIsSubmitted(true);
      setName('');
      setEmail('');
      setLink('');
      setMessage('');
      setAcceptTerms(false);
      
      // Nach 5 Sekunden das Formular wieder anzeigen
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    } catch (err) {
      console.error('Error submitting application:', err);
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const getLinkPlaceholder = () => {
    switch (applicationType) {
      case 'artist':
        return 'YOUR SPOTIFY PROFILE LINK';
      case 'media':
        return 'YOUR MEDIA OUTLET WEBSITE';
      case 'brand':
        return 'YOUR BRAND WEBSITE';
      default:
        return 'YOUR WEBSITE';
    }
  };

  const getLinkLabel = () => {
    switch (applicationType) {
      case 'artist':
        return 'SPOTIFY-LINK';
      case 'media':
      case 'brand':
        return 'WEBSITE-LINK';
      default:
        return 'LINK';
    }
  };

  return (
    <div className="home-apply-form-wrapper">
      <div className="home-apply-form">
        {!isSubmitted ? (
          <>
            <div className="home-apply-form__header">
                <img src="/img/sparkle.svg" alt="Northstar Logo" className="home-apply-form__logo" style={{width: '80px', filter: 'invert(1)'}}/>
              <h2 className="home-apply-form__title">Apply as</h2>
              <div className="home-apply-form__tabs">
                <button 
                  className={`home-apply-form__tab ${applicationType === 'artist' ? 'home-apply-form__tab--active' : ''}`}
                  onClick={() => handleTypeChange('artist')}
                >
                  Music Artist
                </button>
                <button 
                  className={`home-apply-form__tab ${applicationType === 'media' ? 'home-apply-form__tab--active' : ''}`}
                  onClick={() => handleTypeChange('media')}
                >
                  Media Outlet
                </button>
                <button 
                  className={`home-apply-form__tab ${applicationType === 'brand' ? 'home-apply-form__tab--active' : ''}`}
                  onClick={() => handleTypeChange('brand')}
                >
                  Brand Partner
                </button>
              </div>
            </div>
            
            <form className="home-apply-form__form" onSubmit={handleSubmit}>
              <div className="home-apply-form__field">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="NAME"
                  className="home-apply-form__input"
                  required
                />
              </div>
              
              <div className="home-apply-form__field">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="EMAIL"
                  className="home-apply-form__input"
                  required
                />
              </div>
              
              <div className="home-apply-form__field">
                <input
                  type="url"
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                  placeholder={getLinkPlaceholder()}
                  className="home-apply-form__input"
                  required
                />
              </div>
              
              <div className="home-apply-form__field">
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="YOUR MESSAGE"
                  className="home-apply-form__textarea"
                  rows={4}
                />
              </div>
              
              <div className="home-apply-form__terms">
                <label className="home-apply-form__checkbox-label">
                  <input
                    type="checkbox"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                    className="home-apply-form__checkbox"
                  />
                  <span className="home-apply-form__checkbox-text">I ACCEPT THE TERMS OF USE</span>
                </label>
              </div>
              
              {error && <div className="home-apply-form__error">{error}</div>}
              
              <button 
                type="submit" 
                className="home-apply-form__submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
              </button>
            </form>
          </>
        ) : (
          <div className="home-apply-form__success">
            <h2 className="home-apply-form__success-title">Thank you!</h2>
            <p className="home-apply-form__success-message">
              Your application has been successfully submitted. Our team will review it and get back to you soon.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default HomeApplyForm; 